import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavListCommonProps } from 'src/app/components/nav/nav.component';
import { environment } from 'src/environments/environment';
import { GroupBy } from '../_enums/groupby';
import { SiteMapUrl } from '../_enums/sitemap.url';
import { Member } from '../_models/member';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MemberService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  getAll(groupBy?: string) {
    let params = new HttpParams();
    params = groupBy ? params.set('groupBy', groupBy) : params;

    return this.http.get<Member[]>(`${environment.apiUrl}/adherents`, { params: params, headers: this.authService.headers });
  }

  update(member: Member) {
    return this.http.put<Member>(`${environment.apiUrl}/adherents/${member.memberId}`, member, { headers: this.authService.headers });
  }

  add(member: Member) {
    return this.http.post<Member>(`${environment.apiUrl}/adherents`, member, { headers: this.authService.headers });
  }

  delete(memberId: string) {
    return this.http.delete(`${environment.apiUrl}/adherents/${memberId}`, { headers: this.authService.headers });
  }

  get(memberId: string) {
    return this.http.get<Member>(`${environment.apiUrl}/adherents/${memberId}`, { headers: this.authService.headers });
  }

  getAllProjectContractors() {
    return this.http.get<Member[]>(`${environment.apiUrl}/adherents/getMoList`, { headers: this.authService.headers });
  }

  search(email: string) {
    const params = new HttpParams().set('email', email);
    return this.http.get<Member[]>(`${environment.apiUrl}/adherents/search`, { params });
  }

  getReferents(memberId: string) {
    return this.http.get<string[]>(`${environment.apiUrl}/adherents/${memberId}/referents`);
  }

  getNavConfig({ perimeterId }: NavListCommonProps) {
    return {
      header: {
        title: 'ressource_list_title_members',
        actions: [{ label: 'ressource_list_action_add_member', onClick: () => this.router.navigate([`${SiteMapUrl.MenuMember}/new`, 0], { state: { perimeterId } }) }],
        filters: [],
        defaultFilter: GroupBy.family
      },
      getItemConfig: (node: any) => {
        return {
          displayName: `${node.displayName} [${node.code}]`,
          url: `${SiteMapUrl.MenuMember}/${node.memberId}`,
          itemType: 'green'
        };
      },
      getDataSource: this.getAll.bind(this)
    };
  }
}
